import ApiService from '@/services/core/api.service'

const SupplierService = {
  async get (query) {
    return ApiService.get(`logistics-officer/suppliers?${query}`)
  },

  async post (payload) {
    return ApiService.post('logistics-officer/suppliers', payload)
  },

  async put (payload) {
    return ApiService.put(`logistics-officer/suppliers/${payload.id}`, payload)
  }
}

export default SupplierService
